import "@arcgis/map-components/components/arcgis-layer-list";
import { useEffect, useState } from "react";
import Description from "../Description";

function LayerList() {
  const [viewRedy, setViewRedy] = useState(false);

  useEffect(() => {
    if (viewRedy === false) {
      const scenView = document.querySelector("#viewDiv");

      scenView.view.when(() => {
        setViewRedy(false);
      });
    }
  });
  return (
    <>
      <arcgis-layer-list
        dragEnabled={true}
        referenceElement="viewDiv"
      ></arcgis-layer-list>
    </>
  );
}

export default LayerList;
